import Header from "./Header";
import Section9 from "./Section9";
import Section10 from "./Section10";
import { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import ScrollToTop from "./ScrollToTop";
import Contactus from "./Contactus";








//yeha se staert h 
const Contact = () => {
    useEffect(() => {
        AOS.init({ 
            duration: 2500,
            once:true,
        });
        AOS.refresh();
    }, []);

    
    return (
        <div className="bg-red">
            <ScrollToTop />
            <Header/>
            <div className="relative w-full">
                <img src="./images/wertui.jpg" alt="hing" className="w-full h-[400px] max-sm:h-[200px]" />
                <h1 className="text-red font-bold absolute bg-white_blur top-[55%] w-full text-center uppercase max-sm:text-3xl max-sm:top-[57%]">contact us</h1>
            </div>
            <div className="flex px-[6%] py-[3%] max-sm:flex-col max-sm:py-[6%] ">
                <div className="w-2/5 flex flex-col max-sm:w-full max-sm:pb-6 max-sm:pl-[20%]" data-aos="fade-right">
                    <div className="text-white flex mb-6 items-center ">
                        <div className="pr-6 max-sm:pr-2 max-sm:w-1/4">
                            <img src="./images/address.png"  alt="address" className="border-2 border-solid border-grey_blur p-3 rounded-full max-sm:p-2 max-sm:w-3/4" />
                        </div>
                        <div className="max-sm:w-3/4">
                            <h3 className="max-sm:text-xl">Address</h3>
                            <p className="max-sm:text-sm">5163, Kohlapur Road<br/>
                                Kamla Nagar, Delhi <br/>
                            110007 ,INDIA</p>
                        </div>
                    </div>

                    <div className="text-white flex mb-6 items-center">
                        <div className="pr-6 max-sm:pr-2 max-sm:w-1/4">
                            <img src="./images/telephone.png"  alt="telephone" className="border-2 border-solid border-grey_blur p-3 rounded-full max-sm:p-2 max-sm:w-3/4" />
                        </div>
                        <div className="max-sm:w-3/4">
                            <h3 className="capitalize max-sm:text-xl ">give us a call</h3>
                            <p className="max-sm:text-sm ">
                                <a href="tel:022 2784 2212" className="curser-pointer hover:text-yellow hover:underline">+91 9910128609</a><br/>
                                <a href="tel:022 2784 2213" className="curser-pointer hover:text-yellow hover:underline">+91 9810128609</a>
                            </p>
                        </div>
                    </div>
                    <div className="text-white flex mb-6 items-center ">
                        <div className="pr-6 max-sm:pr-2 max-sm:w-1/4">
                            <img src="./images/mail.png"  alt="mail" className="border-2 border-solid border-grey_blur p-3 rounded-full max-sm:p-2 max-sm:w-3/4" />
                        </div>
                        <div className="max-sm:w-3/4">
                            <h3 className="capitalize max-sm:text-xl">email us</h3>
                            <p className="max-sm:text-sm">
                                <a href="mailto:info@purehing.com" className="curser-pointer hover:text-yellow hover:underline">info@purehing.com</a><br/>
                                <a href="mailto:sriraghunathjioverseas@gmail.com" className="curser-pointer hover:text-yellow hover:underline">sriraghunathjioverseas@gmail.com</a>
                            </p>
                        </div>
                    </div>
                    <div className="text-white flex items-center ">
                        <div className="pr-6 max-sm:pr-2 max-sm:w-1/4">
                            <img src="./images/follow-us.png"  alt="follow us" className="border-2 border-solid border-grey_blur p-3 rounded-full max-sm:p-2 max-sm:w-3/4" />
                        </div>
                        <div className="flex items-center gap-3 max-sm:w-3/4">
                            {/* <h3 className="capitalize max-sm:text-xl">email us</h3>
                            <p className="max-sm:text-sm">info@purehing.com<br/>
                            sriraghunathjioverseas@gmail.com</p> */}
                            <img src="./images/instagram.png" alt="insta" className="hover: border-2 border-solid border-yellow rounded-full hover:bg-yellow hover:text-black cursor-pointer"/>
                            <img src="./images/facebook.png" alt="insta"className="hover: border-2 border-solid border-yellow rounded-full hover:bg-yellow hover:text-black cursor-pointer" />
                            <img src="./images/youtube.png" alt="insta" className="hover: border-2 border-solid border-yellow rounded-full hover:bg-yellow hover:text-black cursor-pointer " />
                            <img src="./images/twitter.png" alt="insta" className="hover: border-2 border-solid border-yellow rounded-full hover:bg-yellow hover:text-black cursor-pointer"/>
                        </div>
                    </div>
                </div>
                <Contactus/>
                
            </div>
            
            
            <Section9 />
            <Section10 />
        </div>
    )
}

export default Contact;